import ProduitConfigNiveauxController from './produit.config.niveaux.controller';

export default {
    template: require('./produit.config.niveaux.tpl.html'),
    controller: ProduitConfigNiveauxController,
    bindings: {}
};
